module.exports = __webpack_public_path__ + "img/wbicon.09bcb94f.svg";